<div class="contact-box-container">
  <div class="content">
    <ng-container *ngFor="let contactBox of contacts$ | async">
      <kion-contact-box [box]="contactBox"></kion-contact-box>
    </ng-container>
  </div>
</div>
